<template>
  <modal-component v-show="isOpen" @close="onClose" @mask-click="onClose" :container-width="'40vw'">
    <template slot="header">
        <h2>{{ $t('grid.columns') }}</h2>
    </template>
    <template slot="body">
      <div class="container-fluid">
        <div class="row my-3">
          <div class="col">
            <alerter ref="alertbox"/>
            <text-input v-bind:text-value="searchKey" v-on:update:textValue="searchKey = $event" v-bind:placeholder="$t('placeholder_search')"/>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="container-fluid">
              <div class="row" v-on:contextmenu.prevent="$refs.menu.open($event)">
                <div class="col fd-list mb-3">
                  
                  <!-- List items -->
                  <div class="row fd-item align-items-center py-3" v-for="(column, index) in filteredItems" :key="index" @click="colCheckBoxUpdate(column, !column.selected)">
                    <div class="col-auto">
                      <input type="checkbox" class="ml-0" v-on:click.stop v-model="column.selected" v-bind:value="column.AutoID">
                    </div>
                    <div class="col-7 px-0">
                      {{ column.ColumnTitle }}
                    </div>
                    <div class="col">
                      <select v-model="column.ColumnAlignment" class="custom-select" v-bind:class="{ transparent : (!column.selected)}" v-bind:disabled="false" v-on:click.stop>
                        <option value="0">{{ $t('position.left') }}</option>
                        <option value="1">{{ $t('position.middle') }}</option>
                        <option value="2">{{ $t('position.right') }}</option>
                      </select>
                    </div>
                  </div>
                  <!-- End List items -->
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <context-menu ref="menu">
          <ul>
            <li v-on:click="setAll(true)">{{ $t('select_all') }}</li>
            <li v-on:click="setAll(false)">{{ $t('de_select_all') }}</li>
          </ul>
        </context-menu>
      </div>
    </template>

    <template slot="footer">
      <loading-button :title="$t('grid.save_local_layout')" @click="saveChanges()"/>
    </template>

  </modal-component>
</template>
<script>
import { GridController } from 'controller/gridcontroller.js';
import lodashAssign from 'lodash/assign';
import lodashFind from 'lodash/find';
import lodashIsEqual from 'lodash/isEqual';
import lodashCloneDeep from 'lodash/cloneDeep';
import ModalComponent from 'components/ModalComponent.vue';

import Alerter from 'components/Alerter.vue';
import TextInput from 'components/TextInput.vue';
import ContextMenu from 'components/ContextMenu.vue';

export default {
  name: 'FieldDictionarySearch',
  components: {
    Alerter,
    TextInput,
    'context-menu': ContextMenu,
    'modal-component': ModalComponent
  },
  props: {
    siteRoot: String,
    webController: String,
    existingFlexGridColumns: Array
  },
  mounted () {
    this.gridcontroller = new GridController(this.webController);
  },
  data: function () {
    return {
      searchKey: '',
      listItems: [],
      listItemsCopy: [],
      gridcontroller: null,
      isOpen: false
    };
  },
  methods: {
    showModal: function () {
      this.getData();
      this.isOpen = true;
    },
    saveChanges: function () {
      var selectedItems = {
        Added: [],
        Deleted: [],
        Updated: []
      };

      for (var index in this.listItems) {
        var item = this.listItems[index];
        var original = lodashFind(this.listItemsCopy, {
          FieldName: item.FieldName
        });
        var isequal = lodashIsEqual(item, original);

        if (!isequal) {
          if (item.selected && !original.selected) {
            selectedItems.Added.push(item);
          } else if (!item.selected && original.selected) {
            selectedItems.Deleted.push(item);
          } else if (item.selected === original.selected) {
            selectedItems.Updated.push(item);
          }
        }
      }

      this.$emit('flex-grid-changed', selectedItems);
      this.onClose();
    },
    colCheckBoxUpdate: function (col, selected) {
      this.$set(col, 'selected', selected);
      this.$forceUpdate();
    },
    getData: function () {
      let self = this;
      this.gridcontroller.GetAvailableColumnsForPage().then(res => {
        self.listItems = res;

        for (var index in self.listItems) {
          var item = self.listItems[index];
          //item.ColumnAlignment = 0;
          var existing = lodashFind(self.existingFlexGridColumns, {
            FieldName: item.FieldName
          });

          if (existing != null) {
            lodashAssign(item, existing);
            item.selected = true;
          }
        }
        self.listItemsCopy = lodashCloneDeep(self.listItems);
      })
        .catch(error =>
          self.showAlert(this.$t('errors.error_retrieving'), error));
    },
    showAlert: function (msg, error) {
      console.error(error);
      this.$refs.alertbox.showError(msg);
    },
    setAll: function (value) {
      for (let item of this.filteredItems) {
        this.colCheckBoxUpdate(item, value);
      }
    },
    onClose() {
      this.isOpen = false;
    }
  },
  computed: {
    filteredItems: function () {
      let self = this;

      if (this.listItems.length === 0) {
        return [];
      } else {
        return this.listItems.filter(function (cust) {
          return (
            cust.ColumnTitle.toLowerCase().indexOf(
              self.searchKey.toLowerCase()
            ) >= 0
          );
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .form-control.text-input {
    width: 100%;
  }
  .fd-list {
    height: 45vh; 
    overflow: auto;
    .fd-item {
      border: 1px solid #efefef;
      border-bottom-width: 0px;
      cursor: pointer;
      .form-check-label {
        cursor: pointer;
      }
      &:hover {
        background-color: #f9f9f9;
      }
      &:last-of-type {
        border-bottom-width: 1px;
      }
    }
  }
  .custom-select {
    &.transparent {
      opacity: 0.4;
    }
  }
</style>
